import { stumble } from '@ipfabric/frontend-shared-assets/utils/stumble/stumble';
import type {
  GraphPathLookupParameters,
  PathLookupChecksRequestBody,
  PathLookupPassingTraffic,
} from '@ipfabric/utils';
import { isPathLookupGraphMetadata } from 'components/Graph/GraphState';
import { extractPresetSettings } from 'components/Graph/helpers/extractPresetSettings';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import type { PathLookupCheckFormValues } from '../GraphSidePanel/GraphPathlookup/PathCheck';

export interface SavePathLookupCheckCommand {
  parameters: GraphPathLookupParameters;
  values: PathLookupCheckFormValues;
}

export const savePathLookupCheck: GraphCommandFactory<
  SavePathLookupCheckCommand
> = (cmdContext) => async (command) => {
  await cmdContext.api.request<void, PathLookupChecksRequestBody>({
    url: '/graphs/path-lookup/checks',
    method: 'POST',
    data: {
      expectedPassingTraffic: command.values
        .expectedPassingTraffic as PathLookupPassingTraffic,
      parameters: command.parameters,
      settings: extractPresetSettings(cmdContext.getState().pathlookup.preset),
    },
  });

  cmdContext.updateState((draft) => {
    if (!isPathLookupGraphMetadata(draft.graphMetadata)) {
      stumble(
        'trying to fetch initial expected passing traffic while no pathlookup is loaded',
      );
      return;
    }
    draft.graphMetadata.initialExpectedPassingTraffic =
      command.values.expectedPassingTraffic;
  });
};
